import { render, staticRenderFns } from "./CalendarLinkedPartnerCard.vue?vue&type=template&id=6a45a58b&"
import script from "./CalendarLinkedPartnerCard.vue?vue&type=script&lang=js&"
export * from "./CalendarLinkedPartnerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports